import { useSyncExternalStore } from "react";

import { isNativeApp } from "@/lib/native-bridge";

const subscribe = (): (() => void) => () => undefined;

// 앱 웹뷰 안인지 — 프리렌더·첫 hydrate 는 false 로 그리고 붙은 뒤 실제 값으로 다시 그린다(서버 HTML 과 첫 화면이 같다).
export const useNativeApp = (): boolean => useSyncExternalStore(subscribe, isNativeApp, () => false);
